import { DEFAULT_CURRENCY_ABREVIATURE } from "features/Contactos/constants"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { Dropdown } from "primereact/dropdown"
import { useTranslation } from "react-i18next"
import { useCurrency } from "../../../../common/hooks/useCurrency"
import { setCurrency } from "../../../Documentos/redux/documentosSlice"
import { getCurrencyDocumentActive } from "../../../User/redux/selectors/userSelectors"

const DocumentoSettingsDivisa = () => {
  const { t } = useTranslation()
  const { currencyListFormatDropdown } = useCurrency()

  const documentDivisaActive =
    useSelector(getCurrencyDocumentActive) || DEFAULT_CURRENCY_ABREVIATURE

  const dispatch = useDispatch()

  return (
    <div className='p-0 mt-3 col divisa-container'>
      <p className='text-left'>{t("crear.facturaRec.currencyLabel")}</p>
      <Dropdown
        filter
        options={currencyListFormatDropdown}
        value={documentDivisaActive}
        onChange={({ value }) => {
          dispatch(setCurrency(value))
        }}
        // @ts-expect-error TS(2769): No overload matches this call.
        placeholder={t("crear.facturaRec.placeholderSearchCurrency")}
        emptyFilterMessage={t("crear.facturaRec.emptyMsg")}
        emptyMessage={t("crear.facturaRec.emptyMsg")}
        fluid
      />
    </div>
  )
}

export default DocumentoSettingsDivisa
